const userpermission = {
  getall: 'userpermission/getall',
  getuserpermission: 'userpermission/get-user-permission',
}
export default userpermission
